<template>
    <div class="page">
        <div class="scroller">
            <div class="time-tips" v-if="detail.expireTime">已购买，将于{{ detail.expireTime }}到期</div>
            <div class="list">
                <div class="item" :class="{ disable: !item.ifCanSee }" v-for="item in detail.list" :key="item.id">
                    <div class="top">
                        <div class="name">
                            {{ item.title }}
                        </div>
                        <img class="arrow" src="@/assets/arrow5.png" alt="" />
                    </div>
                    <button class="go" @click="go(item)">前往学习</button>
                </div>
            </div>
        </div>
        <div class="footer" v-if="detail.ifCanBuy" @click="goPay">
            立即参加
        </div>

        <div class="zz" :class="{ active: open }">
            <div class="modal">
                <div class="body">
                    由于合规要求 <br />
                    只能查看近2个月的产品
                </div>
                <div class="footer">
                    <button @click="open = false">取消</button>
                    <button @click="open = false">确定</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import payService from "../../service/private-research-handbook.service";
    export default {
        name: "private-research-handbook",
        data() {
            return {
                detail: {},
                open: false,
            };
        },
        mounted() {
            this.getPrList();
        },
        methods: {
            async getPrList() {
                payService.getPrList().then((res) => {
                    this.detail = res.data;
                });
            },
            go(item) {
                if (!item.ifCanSee) {
                    this.open = true;
                    return;
                }
                if (item.url) { 
                    location.href = item.url;   
                }
            },
            goPay() { 
                 this.$router.push({
                    path: `/pay/PRIVATE_RESEARCH`,
                    query: { id: this.detail.newestId },
                });
            }
        },
    };
</script>

<style lang="scss" scoped src="./private-research-handbook.scss"></style>
